import { useParams } from "react-router-dom";
import backicon from "../../assets/images/backicon.svg";
import styled from "styled-components";
import LocationPicker from "../../Reusablecomponents/LocationPicker/LocationPicker";
import {
  Switch,
  Row,
  Col,
  Form,
  Tooltip,
  Select,
  Button,
  message,
  Card,
  Collapse,
  Spin,
  Upload,
  Modal,
} from "antd";
import {
  setAllEntityList,
  setConsigneeList,
  setConsignerList,
  setCountryList,
  setDriverList,
  setDriverWithVehicle,
  setKpiNameList,
  setLatLongList,
  setRespientList,
  setRoleList,
  setSupllierList,
  setTransporterList,
  setUserInfo,
  setUserList,
  setVehicleList,
  setVehicleType,
  setMyPermissionList,
  ssetOfficeList,
  setSmsTemplate,
  setUserPermissionList,
} from "../../Redux/AuthSlice";
import { jwtDecode } from "jwt-decode";
import edit from "../../assets/images/Editicon.svg";
import { useLocation } from "react-router-dom";
import { useMemo, React, useEffect, useState, useCallback } from "react";
import { Tabs } from "antd";
import {
  EyeOutlined,
  DownloadOutlined,
  DeleteOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { ButtonFilled } from "../../Reusablecomponents/UIButtons";
import { useNavigate } from "react-router-dom";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import { CALL_API } from "../../Common/api";
import FilesTable from "../../Reusablecomponents/FilesTable";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Impersonatetwo } from "../../assets/livetracking/impersonatetwo.svg";

const { Option } = Select;
const { Panel } = Collapse;
const Customstyle = styled.div`
  .impersonate_hover {
    transition: all 0.2s ease;
  }
  .impersonate_hover:hover {
    color: #066d08 !important;
    border-radius: 8px; /* rounded bg */
    transform: scale(1.1); /* zoom effect */
  }

  .impersonate_hover:hover {
  }
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media (max-width: 480px) {
    .head {
      flex-direction: column;
    }
    .head1 {
      align-self: flex-start;
      gap: 10px;
    }
  }

  .tabstyle {
    align-items: center;
  }

  .head1,
  .status {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .status {
    margin-right: 40px;
  }
  .title1 {
    font-weight: 500;
    font-size: 16px;
    margin-top: 15px;
  }
  .icons {
    display: flex;
    gap: 30px;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    margin-top: 10px;
  }
  .ant-switch-checked {
    background-color: #31ab46 !important; /* Green color */
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: #5f6d8c;
  }
  .data {
    font-weight: 400;
    font-size: 16px;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .ant-table-tbody > tr > td > * {
    margin-left: 12px;
  }

  .consignor_tab_container.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: unset !important;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    display: flex;
    gap: 15px;
  }
  .tabsectionfor_table {
    display: flex;
    justify-content: space-between;
  }
`;
const CustomSelect = styled(Select)`
  width: 100%;
  height: 54px;
  border-radius: 10px !important;

  /* Custom border color */
  .ant-select-selector {
    border-radius: 15px !important;
    border: none !important;
    padding: 8px !important;
    background-color: rgb(230, 231, 231) !important;
  }

  /* Custom placeholder color */
  .ant-select-selection-placeholder {
    color: #363636 !important; /* Change placeholder color */
    font-weight: 400;
    font-size: 16px;
  }
  .ant-select-arrow {
    color: #5f6d8c !important;
    padding-right: 10px;
  }
`;
const Viewcompany = () => {
  const dispatch = useDispatch();
  const [impersonateModalVisible, setImpersonateModalVisible] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const location = useLocation();
  const [company, setCompany] = useState(location.state || {});
  const [activekey, setactivekey] = useState("1");
  const { id } = useParams(); // Get the company ID from the URL
  const [isEdit, setIsEdit] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [selectedSections, setSelectedSections] = useState([]);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({
    code: company?.CODE,
    name: company?.COMPNAME,
    email: company?.EMAIL,
    phone: company?.CONTACT,
    emeremail: company?.EMERGENCYEMAIL,
    emerphone: company?.EMERGENCYPHONE,
    contperson: company?.CONTACTPERSON,
    address: company?.ADDRESS,
    designation: company?.DESIGNATION,
  });
  const [filesList, setFilesList] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [CustomData, setCustomData] = useState([]);
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [locationModal, setLocationModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };

  const compUpdateAllowed = useMemo(
    () => hasPermission("MASTERCOMP", "U"),
    [reduxPermissions],
  );
  const compStatusAllowed = useMemo(
    () => hasPermission("MASTERCOMP", "STS"),
    [reduxPermissions],
  );

  const locationClick = (name) => {
    setSelectedItem(name);
    setLocationModal(true);
  };

  const handleLocationSelect = (location) => {
    setFormData((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        place_name: location.place_name,
        latitude: location?.center[0],
        longitude: location?.center[1],
      },
    }));

    setLocationModal(false);
  };

  const GetAllCustomeData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Company`,
      );

      SetAllCustomeData(data);
    } catch (error) {
      message.error("Failed to fetch custom data");
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };

  const loadCustomFields = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Company",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
      message.error("Failed to load custom fields.");
    } finally {
      setLoading(false);
    }
  };
  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Company",
        RefId: company?.MCID,
        Active: 1,
        McId: userInfo?.MCID,
      });
      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };
  const getFileData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getFileTab`, {
      refTab: "COMPANY",
      refId: company?.MCID,
    });
    setFilesList(data);
    setLoading(false);
  };

  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };

  const fetchAllRoleAction = useCallback(async () => {
    try {
      const { data } = await CALL_API("POST", "role/roleAction", {
        MCID: 24,
        ROLEId: 82,
      });
      setPermissions(data);
    } catch (error) {
      console.error("[fetchAllRoleAction] error:", error);
    } finally {
    }
  }, []);

  const fetchSubscriptionData = async (id) => {
    try {
      const { data } = await CALL_API(
        "GET",
        `subscription/get?McId=${company?.MCID}&limit=100&page=1`,
      );
      setSubscriptionDetails(data);
    } catch (error) {
      console.error("[fetchSubscriptionData] error:", error);
    } finally {
    }
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const AddEditForm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);
    const staticFields = [
      // First Row (4 Fields)
      [
        {
          id: 1,
          label: "Company Code",
          type: "text",
          name: "code",
          placeholder: "Enter Company Code",
          maxLength: 50,
          validationRules: [
            { required: true, message: "Company Code is required" },
          ],
        },
        {
          id: 2,
          label: "Company Name",
          type: "text",
          name: "name",
          placeholder: "Enter Company Name",
          maxLength: 50,
          validationRules: [
            { required: true, message: "Company Name is required" },
          ],
        },
        {
          id: 3,
          label: "Email",
          type: "email",
          name: "email",
          placeholder: "Enter your email",
          maxLength: 50,
          validationRules: [{ required: true, message: "Email is required" }],
        },
        {
          id: 4,
          label: "Phone",
          type: "number",
          name: "phone",
          placeholder: "Enter Phone number",
          maxLength: 10,
          validationRules: [
            { required: true, message: "Phone number is required" },
            {
              pattern: /^[0-9]+$/,
              message: "Phone number must be a valid number",
            },
          ],
        },
      ],
      // Second Row (4 Fields)
      [
        {
          id: 5,
          label: "Emergency Email",
          type: "email",
          name: "emeremail",
          placeholder: "Enter Emergency email",
          disabled: false,
        },
        {
          id: 6,
          label: "Emergency Phone",
          type: "text",
          name: "emerphone",
          placeholder: "Enter Emergency Phone",
          validationRules: [
            {
              pattern: /^[0-9]+$/,
              message: "Phone number must be a valid number",
            },
          ],
        },
        {
          id: 7,
          label: "Contact Person",
          type: "text",
          name: "contperson",
          placeholder: "Enter Contact Person",
        },
        {
          id: 8,
          label: "Designation",
          type: "text",
          name: "designation",
          placeholder: "Enter Designation",
        },
      ],
      // Address Row
      [
        {
          id: 9,
          label: "Address",
          type: "location",
          name: "address",
          placeholder: "Enter Address",
        },
        {},
      ],
    ];
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);

  const CustomeDataUpdate = async (MCID, values) => {
    setLoading(true);
    try {
      for (const field of customFields) {
        const fieldName = field.FIELDNAME.replace(/\s+/g, "_").toLowerCase();
        const value = values?.[fieldName];
        const existing = AllCustomeData?.find(
          (item) => item.REFID === MCID && item.CFID === field.CFID,
        );
        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: MCID,
            Value: value,
            DataId: existing.DATAID,
          };
          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
      message.success("Custom fields updated successfully.");
    } catch (error) {
      message.error("Failed to update custom fields.");
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitForm = async (values) => {
    const { data } = await CALL_API("PATCH", "mastercompany/update", {
      Code: values.code,
      CompName: values?.name,
      Status: "1",
      CrBy: company?.CRBY,
      MCID: company?.MCID,
      Email: values?.email,
      Contact: values?.phone,
      Address: values?.address,
      ContactPerson: values?.contperson,
      Designation: values?.designation,
      EmergencyEmail: values?.emeremail || "",
      EmergencyPhone: values?.emerphone || "",
    });
    await CustomeDataUpdate(company?.MCID, values);
    message.success("Data Updated Successfully");
    form.resetFields();
    setIsEdit(false);
    navigate("/MasterCompany", { state: { editIcon: true, Company: company } });
  };

  useEffect(() => {
    if (location.state) {
      setCompany(location.state);
    }
  }, [location.state]);
  const toggleUser = async () => {
    setLoading(true);
    try {
      // Call backend API to toggle status
      const { data } = await CALL_API(
        "GET",
        `mastercompany/delete?mcId=${company?.MCID}`,
      );

      // Extract new status from the response
      const newStatus = data?.data?.status || data?.status;

      if (typeof newStatus === "number") {
        // Update local state with new status
        setCompany((prev) => ({
          ...prev,
          STATUS: newStatus,
        }));

        message.success(
          `User status updated successfully to ${
            newStatus === 1 ? "Active" : "Inactive"
          }`,
        );
      } else {
        console.error("Unexpected response format:", data); // Log unexpected response
        message.error("Unexpected response from server.");
      }
    } catch (error) {
      console.error("Error in toggleUser:", error);
      message.error("An error occurred while updating the user status.");
    } finally {
      setLoading(false);
    }
  };
  const dataSource = [
    {
      key: "1",
      Title: "Location Image",
      FileSize: "53 KB",
      FileType: "Pdf",
      Addedby: (
        <>
          <p>Tony Fernandas</p>
          <p>24th Aug 2024; 07:10 AM</p>
        </>
      ),
    },
    {
      key: "2",
      Title: "Location Image",
      FileSize: "53 KB",
      FileType: "Pdf",
      Addedby: (
        <>
          <p>Tony Fernandas</p>
          <p>24th Aug 2024; 07:10 AM</p>
        </>
      ),
    },
    {
      key: "3",
      Title: "Location Image",
      FileSize: "53 KB",
      FileType: "Pdf",
      Addedby: (
        <>
          <p>Tony Fernandas</p>
          <p>24th Aug 2024; 07:10 AM</p>
        </>
      ),
    },
    {
      key: "4",
      Title: "Location Image",
      FileSize: "53 KB",
      FileType: "Pdf",
      Addedby: (
        <>
          <p>Tony Fernandas</p>
          <p>24th Aug 2024; 07:10 AM</p>
        </>
      ),
    },
    {
      key: "5",
      Title: "Location Image",
      FileSize: "53 KB",
      FileType: "Pdf",
      Addedby: (
        <>
          <p>Tony Fernandas</p>
          <p>24th Aug 2024; 07:10 AM</p>
        </>
      ),
    },
  ];

  const columns = [
    {
      title: "Title",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "File Size",
      dataIndex: "FileSize",
      key: "FileSize",
    },
    {
      title: "File Type",
      dataIndex: "FileType",
      key: "FileType",
    },
    {
      title: "Addedby",
      dataIndex: "Addedby",
      key: "Addedby",
    },

    {
      title: "",
      width: 50,
      key: "actions",
      render: (_, record) => (
        <div>
          <EyeOutlined
            style={{ color: "#5F6D8C", fontSize: "18px", marginRight: "18px" }}
            className="delete-icon"
          />
          <DownloadOutlined
            style={{ color: "#00BC13", fontSize: "18px", marginRight: "18px" }}
          />
          <DeleteOutlined
            style={{ color: "#F20000", fontSize: "18px", marginRight: "18px" }}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    GetAllCustomeData();
    getcustomedatabyRefId();
    loadCustomFields();
    getFileData();
    fetchAllRoleAction();
    fetchSubscriptionData();
  }, []);

  useEffect(() => {
    setSelectedSections(
      subscriptionDetails?.map((item) => ({
        SECCODE: item.SECCODE,
      })),
    );
  }, [subscriptionDetails]);
  // const handleImpersonate = async () => {
  //   try{
  //     const payload = {
  //       UID : userInfo?.UID,
  //       MCID : company?.MCID
  //     };

  //     const {data} = await CALL_API("POST","/mastercompany/impersonate",payload);
  //     message.success("Impersonation successful!");

  //   } catch (error) {
  //      message.error("Impersonation failed!");
  //   console.error("Impersonate error:", error);
  //   }
  // }
  const fetchMyPermissions = async () => {
    try {
      const { data } = await CALL_API("GET", `role/getMyPermissions`);

      // Normalize response (flatten nested arrays if present)
      let items = data ?? [];
      if (
        Array.isArray(items) &&
        items.length === 1 &&
        Array.isArray(items[0])
      ) {
        items = items[0];
      }
      if (Array.isArray(items) && items.some(Array.isArray))
        items = items.flat(1);

      const perms = (items || []).reduce((acc, item) => {
        const code = (item?.SECCODE || "").toUpperCase();
        const action = (item?.ACTION || "").toUpperCase();
        if (!code) return acc;
        if (!acc[code]) acc[code] = new Set();
        acc[code].add(action);
        return acc;
      }, {});

      const permObj = Object.keys(perms).reduce((acc, k) => {
        acc[k] = Array.from(perms[k]);
        return acc;
      }, {});

      dispatch(setMyPermissionList(permObj));
    } catch (err) {
      console.error("Error loading permissions:", err);
      dispatch(setMyPermissionList({}));
    }
  };

  const handleImpersonate = async () => {
    try {
      const payload = {
        UID: userInfo?.UID,
        MCID: company?.MCID,
      };

      const { data } = await CALL_API(
        "POST",
        "/mastercompany/impersonate",
        payload,
      );
      if (data.Token) {
        window.localStorage.removeItem("token");
        window.localStorage.setItem("token", data.Token);
        sessionStorage.removeItem("tokenTimestamp");
        sessionStorage.setItem(
          "tokenTimestamp",
          new Date().getTime().toString(),
        );
        const tokenDetails = jwtDecode(data.Token);
        dispatch(
          setUserInfo({
            email: tokenDetails?.EMAIL,
            firstName: tokenDetails?.FIRSTNM,
            lastName: tokenDetails?.LASTNM,
            MCID: tokenDetails?.MCID,
            ROLEID: tokenDetails?.ROLEID,
            UID: tokenDetails?.UID,
            WialonToken: tokenDetails?.WialonToken,
            ECTSCompId: tokenDetails?.ECTSCompId,
            NexusCompId: tokenDetails?.NexusCompId,
            COMPNAME: tokenDetails?.COMPNAME,
            SYSADM: tokenDetails?.SYSADM,
          }),
        );
        fetchConsigneeList(tokenDetails?.MCID);
        fetchTransporterList(tokenDetails?.MCID);
        fetchConsignerList(tokenDetails?.MCID);
        fetchAllVehicleList(tokenDetails?.MCID);
        fetchSupllierList(tokenDetails?.MCID);
        fetchRoleList(tokenDetails?.MCID);
        fetchOfficeList(tokenDetails?.MCID);
        fetchVehicleType();
        fetchCountryList();
        fetchLatLongList();
        fetchUserLiat();
        fetchSMSTemplateOptions();
        fetchDriverList(tokenDetails?.MCID);
        fetchKpiNameList(tokenDetails?.MCID);
        fetchAllEntityList(tokenDetails?.MCID);
        fetchRespientList(tokenDetails?.MCID);
        fetchDriverWithVehicle(tokenDetails?.MCID);
        fetchUserPermissionList(tokenDetails?.MCID, tokenDetails?.UID);
        fetchMyPermissions();
        navigate("/Home");

        message.success("Impersonation successful!");
      } else {
        message.error("No token returned from impersonation API!");
      }
    } catch (error) {
      message.error("Impersonation failed!");
      console.error("Impersonate error:", error);
    }
  };

  const showImpersonateConfirm = () => {
    setImpersonateModalVisible(true);
  };

  // Handle Yes/No
  const handleImpersonateYes = async () => {
    setImpersonateModalVisible(false);
    await handleImpersonate();
  };
  const handleImpersonateNo = () => {
    setImpersonateModalVisible(false);
  };

  const fetchConsigneeList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 3,
    });
    dispatch(setConsigneeList(data));
  };
  const fetchTransporterList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 2,
    });
    dispatch(setTransporterList(data));
  };
  const fetchConsignerList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 1,
    });
    dispatch(setConsignerList(data));
  };
  const fetchAllVehicleList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getAllRegNo", {
      mcId: MCID,
    });
    dispatch(setVehicleList(data));
  };
  const fetchSupllierList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getSupplier", {
      mcId: MCID,
    });
    dispatch(setSupllierList(data));
  };
  const fetchRoleList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getRole", {
      mcId: MCID,
    });
    dispatch(setRoleList(data));
  };
  const fetchOfficeList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getoffice", {
      mcId: MCID,
    });
    dispatch(ssetOfficeList(data));
  };
  const fetchVehicleType = async (MCID) => {
    const { data } = await CALL_API("GET", "common/getVehicleType");
    dispatch(setVehicleType(data));
  };
  const fetchCountryList = async () => {
    const { data } = await CALL_API("GET", "common/getAllCountries");
    dispatch(setCountryList(data));
  };
  const fetchLatLongList = async () => {
    const { data } = await CALL_API("GET", `common/getLatLongLocation`);
    dispatch(setLatLongList(data));
  };
  const fetchUserLiat = async () => {
    const { data } = await CALL_API("GET", `user/getAll`);
    dispatch(setUserList(data));
  };
  const fetchSMSTemplateOptions = async () => {
    const { data } = await CALL_API("GET", "mastertable/msgtemplate", {});
    dispatch(setSmsTemplate(data));
  };
  const fetchDriverList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getDriver", {
      mcId: MCID,
    });
    dispatch(setDriverList(data));
  };
  const fetchKpiNameList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getKPIName", {
      mcId: MCID,
    });
    dispatch(setKpiNameList(data));
  };
  const fetchAllEntityList = async (MCID) => {
    const { data } = await CALL_API("GET", `common/getEntity?mcId=${MCID}`);
    dispatch(setAllEntityList(data));
  };
  const fetchRespientList = async (MCID) => {
    const { data } = await CALL_API("GET", `common/getRecpList?mcId=${MCID}`);
    dispatch(setRespientList(data));
  };
  const fetchDriverWithVehicle = async (MCID) => {
    const { data } = await CALL_API(
      "GET",
      `common/getVehicleWithDriver?mcid=${MCID}`,
    );
    dispatch(setDriverWithVehicle(data?.recordsets[0]));
  };
  const fetchUserPermissionList = async (MCID, UID) => {
    const { data } = await CALL_API(
      "POST",
      "role/getCurrentUserOrAdminPermission",
      {
        MCID: MCID,
        UID: UID,
      },
    );
    dispatch(setUserPermissionList(data));
  };
  return (
    <>
      <Customstyle>
        <div className="head">
          <div className="head1">
            <div>
              <img
                src={backicon}
                onClick={() => {
                  navigate(-1);
                }}
              />
            </div>
            <div className="title">
              <p>Company Details - {company?.COMPNAME}</p>
            </div>
          </div>
          <div className="head2">
            <div className="head1">
              <div className="status">
                <div className="title1">
                  <p>Status </p>
                </div>
                <div>
                  {" "}
                  <Switch
                    disabled={!compStatusAllowed}
                    checked={company?.STATUS === 1}
                    onChange={toggleUser}
                    loading={loading}
                  />
                </div>
              </div>
              <div className="icons">
                {/* <img src={upload} /> */}
                <Tooltip title="Impersonate" placement="bottom">
                  {/* <img src={impersonatetwo} className="impersonate_hover"
    style={{ width: 30, height: 30, cursor: "pointer" }}
    onClick={showImpersonateConfirm}
    /> */}

                  <Impersonatetwo
                    disabled={!compUpdateAllowed}
                    onClick={showImpersonateConfirm}
                    className="impersonate_hover"
                    style={{
                      width: 50,
                      height: 50,
                      cursor: compUpdateAllowed ? "pointer" : "not-allowed",
                    }}
                  />
                </Tooltip>
                <Modal
                  open={impersonateModalVisible}
                  footer={null}
                  closable={true}
                  onCancel={handleImpersonateNo}
                  centered
                  bodyStyle={{
                    textAlign: "center",
                    padding: "32px 24px 24px 24px",
                  }}
                >
                  <h2 style={{ marginBottom: 0 }}>Are you sure,</h2>
                  <div
                    style={{
                      margin: "12px 0 24px 0",
                      color: "#222",
                      fontSize: 16,
                    }}
                  >
                    You want to Impersonate this Company Admin?
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 16,
                    }}
                  >
                    <button
                      style={{
                        background: "#2C963D",
                        color: "#fff",
                        border: "none",
                        borderRadius: 20,
                        width: 100,
                        height: 40,
                        fontWeight: 600,
                        fontSize: 16,
                        cursor: "pointer",
                      }}
                      onClick={handleImpersonateYes}
                    >
                      Yes
                    </button>
                    <button
                      style={{
                        background: "#F5F5F5",
                        color: "#6B6B6B",
                        border: "none",
                        borderRadius: 20,
                        width: 100,
                        height: 40,
                        fontWeight: 400,
                        fontSize: 16,
                        cursor: "pointer",
                      }}
                      onClick={handleImpersonateNo}
                    >
                      No
                    </button>
                  </div>
                </Modal>
                <Tooltip title={!compUpdateAllowed ? "No permission" : ""}>
                  <img
                    src={edit}
                    style={{
                      cursor: compUpdateAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!compUpdateAllowed) return;
                      setIsEdit(true);
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: "20px" }}>
          <Row gutter={[24, 24]}>
            <Col style={{ paddingRight: "80px" }}>
              <p className="company">Company Code</p>
              <p> {company?.CODE || "---"}</p>
              <p className="company">Emergency Email </p>
              <p className="data">{company?.EMAIL || "---"}</p>
              <p className="company">Address</p>
              <p className="data">{company?.ADDRESS || "---"}</p>
            </Col>
            <Col style={{ paddingRight: "80px" }}>
              <p className="company">Company Name</p>
              <p className="data"> {company?.COMPNAME || "---"}</p>
              <p className="company">Emergency Contact</p>
              <p className="data"> {company?.EMERGENCYPHONE || "---"}</p>
            </Col>
            <Col style={{ paddingRight: "80px" }}>
              <p className="company">Email</p>
              <p className="data"> {company?.EMAIL || "---"}</p>
              <p className="company">Contact Person</p>
              <p className="data"> {company?.CONTACTPERSON || "---"}</p>
            </Col>
            <Col style={{ paddingRight: "80px" }}>
              <p className="company">Phone</p>
              <p className="data"> {company?.CONTACT || "---"}</p>
              <p className="company">Designation</p>
              <p className="data"> {company?.DESIGNATION || "---"}</p>
            </Col>
            <Col>
              {Array.isArray(CustomData) &&
                CustomData.length > 0 &&
                CustomData.map((field) => (
                  <div className="company" key={field.CFID}>
                    <label>{field.FIELDNAME}</label>
                    <p>{field.VALUE || "-"}</p>
                  </div>
                ))}
            </Col>
          </Row>
          <br />
          <br />
          <div className="tabsectionfor_table">
            <div>
              <Tabs
                onChange={(key) => setactivekey(key)}
                type="card"
                items={[
                  {
                    label: "Files",
                    key: "1",
                  },
                  {
                    label: "Subscription", // Tab 2
                    key: "2",
                  },
                ]}
              />
            </div>

            <div>
              {activekey === "1" && (
                <div>
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "COMPANY",
                              refId: company?.MCID,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "COMPANY",
                              refId: company?.MCID,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                  </Upload>
                </div>
              )}
            </div>
          </div>
          {activekey === "1" && (
            <Spin spinning={loading}>
              <FilesTable filesList={filesList} getFileData={getFileData} />
            </Spin>
          )}
          {activekey === "2" && (
            <div className="mt-0 pt-0">
              <Card style={{ backgroundColor: "transparent", border: "none" }}>
                <Collapse defaultActiveKey={["0"]}>
                  {permissions?.map((group, groupIndex) => (
                    <Panel key={groupIndex} header={group?.Group}>
                      {group.Sections?.filter((item) =>
                        selectedSections?.some(
                          (val) => val?.SECCODE === item.secCode,
                        ),
                      ).map((section, sectionIndex) => {
                        const isSelected = selectedSections?.some(
                          (item) => item.SECCODE === section.secCode,
                        );

                        return (
                          <div
                            className="d-flex justify-content-between p-2"
                            style={{
                              background: "#f1f1f1",
                              color: "#000",
                              borderRadius: "8px",
                              padding: "10px",
                              marginBottom: "8px",
                            }}
                            key={sectionIndex}
                          >
                            <strong>{section.section}</strong>
                          </div>
                        );
                      })}
                    </Panel>
                  ))}
                </Collapse>
              </Card>
            </div>
          )}
        </div>
        <ReusableDrawer
          title="Editing Master Company"
          open={isEdit}
          setOpen={setIsEdit}
          onOk={() => form.submit}
          onCancel={() => setIsEdit(false)}
          footer={[
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Button
                key="cancel"
                className="cancel-btn"
                onClick={() => setIsEdit(false)}
                style={{
                  borderRadius: "26px",
                  backgroundColor: "#E8FFEC",
                  color: "#2C963D",
                  borderColor: "#E8FFEC",
                  width: "118px",
                  height: "38px",
                }}
              >
                Cancel
              </Button>
              <ButtonFilled
                key="create"
                type="primary"
                onClick={() => form.submit()}
              >
                Update
              </ButtonFilled>
            </div>,
          ]}
          children={
            <GridBuilder
              formStructureJson={AddEditForm}
              handleSelectChange={handleSelectChange}
              handleChange={handleChange}
              formSubmit={handleSubmitForm}
              initialValues={formData}
              locationClick={locationClick}
              form={form}
            />
          }
        />
        <LocationPicker
          visible={locationModal}
          onClose={() => setLocationModal(false)}
          onSelect={handleLocationSelect}
        />
      </Customstyle>
    </>
  );
};

export default Viewcompany;
